'use client';

import { EzNewswireLogo } from 'icons/EzNewswireLogo';
import { useEffect, useState } from 'react';
import { AdSlot } from '@/app_components/AdSlot/Adslot';
import { Icon } from '@/app_components/common/Icon';
import { Link } from '@/app_components/common/Link';
import { useAdContext } from '@/app_lib/providers/AdProvider';

interface RightRailProps {
  ctaUrl: string;
}

export const RightRail = ({ ctaUrl }: RightRailProps) => {
  const { pageAdConfig } = useAdContext();
  const [isConfigDefined, setIsConfigDefined] = useState<boolean>(false);

  useEffect(() => {
    if (pageAdConfig) {
      setIsConfigDefined(true);
    }
  }, [pageAdConfig]);

  return (
    <div
      className='md:sticky md:top-[calc(var(--leaderboard-height)+var(--header-height)+var(--disclaimer-height)+20px)] md:self-start flex flex-col gap-10 ml-auto mr-auto max-w-[300px]'
      data-cy='ez-newswire-right-rail'
    >
      <div
        className='flex flex-col p-6 lg:p-8 xl:p-10 items-center gap-6 border rounded-sm stroke-secondary bg-pure shadow-[0_0_24px_0_rgba(17,17,17,0.04)] font-graphik-compact text-primary w-full'
        data-cy='ez-newswire-right-rail-cta'
      >
        <div className='flex flex-col items-center gap-4'>
          <EzNewswireLogo />
          <div className='text-center typography-default font-normal'>
            Announce your business updates on premium publications.
          </div>
        </div>
        <Link
          className='flex justify-center gap-2 px-8 py-4 rounded-full button-secondary button-secondary-hover'
          data-cy='ez-newswire-right-rail-cta-button'
          href={`${ctaUrl}&utm_content=cta_button`}
          target='_blank'
        >
          <span className='text-base font-medium leading-4'>Find out how</span>
          <Icon
            icon='ExternalLink'
            size='sm'
            strokeWidth={2}
          />
        </Link>
      </div>
      {isConfigDefined && (
        <AdSlot
          index={1}
          placementName='RightRailFlex'
        />
      )}
    </div>
  );
};
